import { Button } from "~/common/mui";

export interface Props {
  label: string;
  href: string;
}

export function create(props: Props) {
  return <Button href={props.href}>{props.label}</Button>;
}
